<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>



<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row" *ngIf="SelectedpatientDetails">
          <div class="col-md-1 ">
            <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-4 padding-left-0px">
            <div class="row row-height-17px margin-left-0px">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.OwnerName}} </label>
              </div>
            </div>
            <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{SelectedpatientDetails.EggName}}) </label>
              </div>
            </div>
            <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
              </div>
            </div>-->
            <div class="row row-height-17px">
              <div class="col-md-12">
                
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerAgeYears}},{{SelectedpatientDetails.OwnerFormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerTelephone1}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-2 padding-right-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
              </div>
              <div class="col-md-9 padding-left-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
              </div>

            </div>

          </div>
          <div class="col-md-6  padding-right-0px">
            <!--<div class="row font-size-12px">
              <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
              </div>:
              <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
              </div>
            </div>-->
            <div class="row font-size-12px">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="PickupData2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{PickupData2.ActivityStatus}}</label>
              </div>
            </div>
            <div class="row font-size-12px" *ngIf="FollicularPickupEndInfo">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Pickup Date </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="FollicularPickupEndInfo">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupdate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
            <!--<div class="row">
              <div class="col-md-1 margin-left-auto padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                </div>
              <div class="col-md-1 padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
              </div>

               <div class="col-md-1 padding-left-7px">

                <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
              </div>

            </div>-->
            <div class="row margin-right-0px">
              <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
              </div>
              <div class="Dsa2" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
              </div>
              <div class="Dsa3" *ngIf="DSADetails">

                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.close('Load')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="card">
       
          <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
            <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
              <div class="col-md-6 padding-right-0px">
                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                  Follicular Pickup
                </label>
              </div>
              <div class="col-md-5  padding-right-0px display-edit">
                <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                <div class="row float-right">
                  <div class="col-md-12 margin-top-3px padding-left-0px" *ngIf="FollicularPickupEndInfo && PickupData2 ">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="pickup()"
                       title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp || PickupData2.ActivityStatus !=='Completed'">Is Pickup Confirmed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printpickup()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>




              </div>

            </div>
          </div>
          <div class="chatsd product-chart-wrapper product-chat-follicular-popup agreement-chart-wrapper ps  padding-lrt " data-ps-id="dfsfsde">

            <div class="card-body">
              <div *ngIf="FollicularPickupEndInfo">
                <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExampleOvum">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOvum">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOvum" aria-expanded="true" aria-controls="collapseOvum">
                                Ovulation Trigger
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto"
                                    hidden>Clear</button>
                            <button (click)="SaveOvulationtrigger()"
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="!FollicularPickupEndInfo.IsPickedUp" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                        </div>


                      </div>

                      <div id="collapseOvum" class="collapse show" aria-labelledby="headingOvum" data-parent="#accordionExampleOvum">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <!--<div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Trigger Type </label>
                                </div>


                                <div class="col-md-4">

                                  <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.triggertype}}</label>

                                </div>

                              </div>


                            </div>
                          </div>-->
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row font-size-12px">
                                <div class="col-md-3  text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class=" margin-bottom-0px">Trigger Type </label>
                                </div>:


                                <div class="col-md-4 margin-tg-auto">
                                  <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.triggertype}}</label>
                                  <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                           id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                           [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                           name="FollicularPickupEndInfo.MedicineCode" required>
                                  </CustomDataByRequestType>-->
                                  <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                  <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                  [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                  name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                  maxlength="100" required>-->
                                  <!--<small class="form-text text-danger"
                                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                </div>

                              </div>


                            </div>
                          </div>
                          <div class="accordion margin-bottom-20px margin-top-3px" id="accordionExampleDOse1">
                            <div class="card margin-bottom-5px">
                              <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px"
                                   id="headingDose1">
                                <div class="row">
                                  <div class="col-md-4 text-align-center padding-right-0px">
                                    <h5 class="mb-0 height-24px">
                                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px border-left-female"
                                              type="button" data-toggle="collapse" data-target="#collapseDoseOne"
                                              aria-expanded="true" aria-controls="collapseDoseOne">
                                        <h4 class="margin-bottom-0px margin-left-8px font-size-16px">Dose1</h4>
                                      </button>
                                    </h5>
                                  </div>

                                </div>


                              </div>

                              <div id="collapseDoseOne" class="collapse show" aria-labelledby="headingDOseOne" data-parent="#accordionExampleDOse1">
                                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                  <div class="card">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Trigger Date </label>
                                          </div>:


                                          <div class="col-md-5 margin-tg-auto">

                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->
                                            <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerDate | date:'MMM-dd-yyyy'}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Trigger Time </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">


                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.TriggerTime" placeholder="Schedule Time"
                                            [(ngModel)]="FollicularPickupEndInfo.TriggerTime"
                                            name="FollicularPickupEndInfo.TriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvulationTriggerTime" placeholder="Trigger Time"
                                            [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"
                                            name="FollicularPickupEndInfo.OvulationTriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <!--<input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime" name="FollicularPickupEndInfo.OvulationTriggerTime">
                                            <ngx-material-timepicker #picker></ngx-material-timepicker>-->
                                            <!--<ngb-timepicker [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"></ngb-timepicker>-->
                                            <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerTime| slice:11}}</label>
                                            <!--<label class="margin-bottom-0px " *ngIf="OvulationDateTime">{{OvulationDateTime|date: 'hh:mm a'}}</label>-->
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Medicine </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.MedicineName}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="margin-bottom-0px">Dose </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">

                                            <!--<input type="text" class="form-control" placeholder="Dose" id="FollicularPickupEndInfo.Dosage"
                                            [(ngModel)]="FollicularPickupEndInfo.Dosage" required
                                            name="FollicularPickupEndInfo.Dosage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                            maxlength="100">-->

                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.Dosage}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="margin-bottom-0px">Batch </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.BatchNo}}</label>


                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Expiry Date </label>
                                          </div>:


                                          <div class="col-md-5 margin-tg-auto">

                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->
                                            <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.ExpiryDate| date:'MMM-dd-yyyy'}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="accordion" id="accordionExampleDOse2"
                               *ngIf="FollicularPickupEndInfo.triggertype=='Dual Trigger' || FollicularPickupEndInfo.triggertype=='Double Trigger' ">
                            <div class="card margin-bottom-5px">
                              <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingDose2">
                                <div class="row">
                                  <div class="col-md-4 text-align-center padding-right-0px">
                                    <h5 class="mb-0 height-24px">
                                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px border-left-female" type="button" data-toggle="collapse" data-target="#collapseDoseTwo" aria-expanded="true" aria-controls="collapseDoseTwo">
                                        <h4 class="margin-bottom-0px margin-left-8px font-size-16px">Dose2</h4>
                                      </button>
                                    </h5>
                                  </div>

                                </div>


                              </div>

                              <div id="collapseDoseTwo" class="collapse show" aria-labelledby="headingDOseTwo" data-parent="#accordionExampleDOse2">
                                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                  <div class="card">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Trigger Date </label>
                                          </div>:


                                          <div class="col-md-5 margin-tg-auto">

                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->
                                            <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerDate2| date:'MMM-dd-yyyy'}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Trigger Time </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">


                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.TriggerTime" placeholder="Schedule Time"
                                            [(ngModel)]="FollicularPickupEndInfo.TriggerTime"
                                            name="FollicularPickupEndInfo.TriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvulationTriggerTime" placeholder="Trigger Time"
                                            [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"
                                            name="FollicularPickupEndInfo.OvulationTriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <!--<input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime" name="FollicularPickupEndInfo.OvulationTriggerTime">
                                            <ngx-material-timepicker #picker></ngx-material-timepicker>-->
                                            <!--<ngb-timepicker [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"></ngb-timepicker>-->
                                            <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerTime2| slice:11}}</label>
                                            <!--<label class="margin-bottom-0px " *ngIf="OvulationDateTime">{{OvulationDateTime|date: 'hh:mm a'}}</label>-->
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Medicine </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.MedicineName2}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="margin-bottom-0px">Dose </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">

                                            <!--<input type="text" class="form-control" placeholder="Dose" id="FollicularPickupEndInfo.Dosage"
                                            [(ngModel)]="FollicularPickupEndInfo.Dosage" required
                                            name="FollicularPickupEndInfo.Dosage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                            maxlength="100">-->

                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.Dosage2}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="margin-bottom-0px">Batch </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.BatchNo2}}</label>

                                            <!--<input type="text" class="form-control" [disabled]="true" id="CurrentSaveFollicularPickupsDetailV2Request.Batch" placeholder="Batch"
                                            [(ngModel)]="CurrentSaveFollicularPickupsDetailV2Request.Batch"
                                            name="CurrentSaveFollicularPickupsDetailV2Request.Batch" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Expiry Date </label>
                                          </div>:


                                          <div class="col-md-5 margin-tg-auto">

                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->
                                            <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.ExpiryDate2 | date:'MMM-dd-yyyy'}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitSchedule()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExampleSch" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px"
                           id="headingSch">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapseSch"
                                      aria-expanded="true" aria-controls="collapseSch">
                                Schedule
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto"
                                    hidden>Clear</button>
                            <button type="submit"
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="PickupData2.ActivityStatus !=='Completed'"
                                    [disabled]="DateOfBirth.errors?.required || ActivityTime.errors?.required">
                            Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                          </div>-->
                        </div>


                      </div>

                      <div id="collapseSch" class="collapse show" aria-labelledby="headingSch" data-parent="#accordionExampleSch">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-3">
                                  <label class="font-weight-normal font-size-14">Add/Edit</label>
                                </div>
                                <div class="col-md-3 text-align-right">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>
                              </div>

                            </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Planned Date </label>
                                    </div>


                                    <div class="col-md-3 padding-right-0px">

                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp2" [(ngModel)]="OvumPlannedPickupDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth2="ngModel" required>
                                        <small class="form-text text-danger"
                                               *ngIf="(!DateOfBirth2.valid && (DateOfBirth2.dirty || DateOfBirth2.touched) && DateOfBirth2.errors.required)">(Field cannot be left blank)</small>
                                        <a (click)="d2.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Planned Time </label>
                                    </div>


                                    <div class="col-md-3 padding-right-0px">

                                      <input type="text" class="form-control" id="FollicularPickupEndInfo.PlannedTime"
                                             [(ngModel)]="FollicularPickupEndInfo.PlannedTime"
                                             name="FollicularPickupEndInfo.PlannedTime"
                                             maxlength="20" minlength="1" #PlannedTime="ngModel" pattern="^[\sa-zA-Z0-9,:._\-?]*$">
                                      <small class="form-text text-danger"
                                             *ngIf="(!PlannedTime.valid && (PlannedTime.dirty || PlannedTime.touched) && PlannedTime.errors.required)">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!PlannedTime.valid && PlannedTime.errors.pattern)">(special characters are not allowed)</small>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <!--<div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row font-size-12px">
                                    <div class="col-md-3  text-align-right padding-right-5px">
                                      <label class="font-weight-normal font-size-12px margin-bottom-0px">Planned Time </label>
                                    </div>:
                                    <div class="col-md-3 padding-right-0px  padding-left-9px">
                                      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.OvumPlannedPickupTime}}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>-->
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Date </label>
                                    </div>


                                    <div class="col-md-3 padding-right-0px">

                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp1" [(ngModel)]="OvumPickupdate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                        <small class="form-text text-danger"
                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Time </label>
                                    </div>


                                    <div class="col-md-3 padding-right-0px">

                                      <input type="time" class="form-control" id="FollicularPickupEndInfo.OvumPickupTime" placeholder="Trigger Time"
                                             [(ngModel)]="FollicularPickupEndInfo.OvumPickupTime"
                                             name="FollicularPickupEndInfo.OvumPickupTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" required />

                                    </div>

                                  </div>


                                </div>
                              </div>




                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>


              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitSchedule()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExampleSch" *ngIf="PickupData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSch">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSch" aria-expanded="true" aria-controls="collapseSch">
                                Schedule
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="DateOfBirth.errors?.required || ActivityTime.errors?.required">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                          </div>-->
                        </div>


                      </div>

                      <div id="collapseSch" class="collapse show" aria-labelledby="headingSch" data-parent="#accordionExampleSch">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">


                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row my-profile-form">
                                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                      <div class="row">
                                        <div class="col-md-3 text-align-right margin-tg-auto ">
                                          <label for="diaplayName" class="margin-bottom-0px">Planned Date </label>
                                        </div>:


                                        <div class="col-md-3 margin-tg-auto ">

                                          <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPlannedPickupDate | date:'MMM-dd-yyyy'}}</label>
                                        </div>

                                      </div>


                                    </div>
                                  </div>
                                  <div class="row font-size-12px">
                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                      <label class="margin-bottom-0px">Planned Time </label>
                                    </div>:
                                    <div class="col-md-3 margin-tg-auto ">
                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPlannedPickupTime| slice:11}}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Actual Date </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto ">

                                      <!--<div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp1" [(ngModel)]="OvumPickupdate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                        <small class="form-text text-danger"
                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupdate | date:'MMM-dd-yyyy'}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Actual Time </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">

                                      <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvumPickupTime" placeholder="Trigger Time"
                                      [(ngModel)]="FollicularPickupEndInfo.OvumPickupTime"
                                      name="FollicularPickupEndInfo.OvumPickupTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" required />-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupTime| slice:11}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>




                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExampleTea" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px"
                           id="headingTea">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapseTea" aria-expanded="true" aria-controls="collapseTea">
                                Team
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto"
                                    hidden>Clear</button>
                            <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="PickupData2.ActivityStatus !=='Completed'"
                                    [disabled]="Surgeon.errors?.required || AsstSurgeon.errors?.required || Anaesthetist.errors?.required">
                            Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                          </div>-->
                        </div>


                      </div>

                      <div id="collapseTea" class="collapse show" aria-labelledby="headingTea" data-parent="#accordionExampleTea">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">


                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Surgeon </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                               id="FollicularPickupEndInfo.Surgeon" SelectedValue="FollicularPickupEndInfo.Surgeon"
                                                               [(ngModel)]="FollicularPickupEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                               name="FollicularPickupEndInfo.Surgeon" required #Surgeon="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<input type="text" class="form-control" placeholder="Surgeon" id="FollicularPickupEndInfo.SurgeonName"
                                      [(ngModel)]="FollicularPickupEndInfo.SurgeonName" required
                                      name="FollicularPickupEndInfo.SurgeonName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                      maxlength="100">-->
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                            id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                           </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                    <!--<div class="col-md-2 padding-left-0px">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                    </div>-->

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto">
                                      <label class="font-size-12px margin-bottom-0px"><span>*</span>{{AsstSurgeonPickup}}</label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                               id="FollicularPickupEndInfo.AsstSurgeon" SelectedValue=""
                                                               [(ngModel)]="FollicularPickupEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                               name="FollicularPickupEndInfo.AsstSurgeon" required #AsstSurgeon="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<input type="text" class="form-control" placeholder="Asst.Surgeon" id="FollicularPickupEndInfoAsstSurgeonName"
                                      [(ngModel)]="FollicularPickupEndInfo.AsstSurgeonName" required
                                      name="FollicularPickupEndInfo.AsstSurgeonName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                      maxlength="100">-->
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                            id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                           </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                    <!--<div class="col-md-2 padding-left-0px">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                    </div>-->
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Anaesthetist </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                               id="FollicularPickupEndInfo.Anesthesiologist" SelectedValue="FollicularPickupEndInfo.Anesthesiologist"
                                                               [(ngModel)]="FollicularPickupEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                               name="FollicularPickupEndInfo.Anesthesiologist" required #Anaesthetist="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<input type="text" class="form-control" placeholder="Anesthesiologist" id="FollicularPickupEndInfo.AnesthesiologistName"
                                      [(ngModel)]="FollicularPickupEndInfo.AnesthesiologistName" required
                                      name="FollicularPickupEndInfo.AnesthesiologistName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                      maxlength="100">-->
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                              id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                             </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                    <!--<div class="col-md-2 padding-left-0px">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                    </div>-->
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Embryologist </label>
                                    </div>


                                    <div class="col-md-3">
                                      <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                               id="FollicularPickupEndInfo.Embryologist" SelectedValue="FollicularPickupEndInfo.Embryologist"
                                                               [(ngModel)]="FollicularPickupEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeEmbryologist($event)"
                                                               name="FollicularPickupEndInfo.Embryologist" required #Embryologist="ngModel">
                                      </CustomDataByRequestType>
                                      <!--<input type="text" class="form-control" placeholder="Anesthesiologist" id="FollicularPickupEndInfo.AnesthesiologistName"
                                      [(ngModel)]="FollicularPickupEndInfo.AnesthesiologistName" required
                                      name="FollicularPickupEndInfo.AnesthesiologistName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                      maxlength="100">-->
                                      <!--<CodeTypeValue CodeType="FNSTS"
                                                              id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                      name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                             </CodeTypeValue>-->
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                    <!--<div class="col-md-2 padding-left-0px">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                    </div>-->
                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

              </div>

              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExampleTea" *ngIf="PickupData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTea">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTea" aria-expanded="true" aria-controls="collapseTea">
                                Team
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="Surgeon.errors?.required || AsstSurgeon.errors?.required || Anaesthetist.errors?.required">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>

                        </div>


                      </div>

                      <div id="collapseTea" class="collapse show" aria-labelledby="headingTea" data-parent="#accordionExampleTea">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">


                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Surgeon </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                               id="FollicularPickupEndInfo.Surgeon" SelectedValue="FollicularPickupEndInfo.Surgeon"
                                                               [(ngModel)]="FollicularPickupEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                               name="FollicularPickupEndInfo.Surgeon" required #Surgeon="ngModel">
                                      </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.SurgeonName}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Asst.Surgeon </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                          id="FollicularPickupEndInfo.AsstSurgeon" SelectedValue=""
                                          [(ngModel)]="FollicularPickupEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                          name="FollicularPickupEndInfo.AsstSurgeon" required #AsstSurgeon="ngModel">
                                      </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.AsstSurgeonName}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthetist </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                         id="FollicularPickupEndInfo.Anesthesiologist" SelectedValue="FollicularPickupEndInfo.Anesthesiologist"
                                         [(ngModel)]="FollicularPickupEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                         name="FollicularPickupEndInfo.Anesthesiologist" required #Anaesthetist="ngModel">
                                      </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.AnesthesiologistName}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryologist </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">
                                      <!--<CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                         id="FollicularPickupEndInfo.Embryologist" SelectedValue="FollicularPickupEndInfo.Embryologist"
                                         [(ngModel)]="FollicularPickupEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeEmbryologist($event)"
                                         name="FollicularPickupEndInfo.Embryologist" required #Embryologist="ngModel">
                                      </CustomDataByRequestType>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.EmbryologistName}}</label>
                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

              </div>

              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitProcedureDetails()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                Procedure Details
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit"
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="PickupData2.ActivityStatus !=='Completed'"
                                    [disabled]="Complication.errors?.required || Route.errors?.required || Batch.errors?.required || Needle.errors?.required || Anaesthesia.errors?.required  ">
                            Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                          </div>-->
                        </div>


                      </div>

                      <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-3">
                                  <label class="font-weight-normal font-size-14">Add/Edit</label>
                                </div>
                                <div class="col-md-3 text-align-right">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>
                              </div>

                            </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Anaesthesia </label>
                                    </div>


                                    <div class="col-md-3">
                                      <!--<input type="text" class="form-control" placeholder="Needle Used"
                                      id="FollicularPickupEndInfo.NeedleUsed"
                                      [(ngModel)]="FollicularPickupEndInfo.NeedleUsed"
                                      name="FollicularPickupEndInfo.NeedleUsed" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <CodeTypeValue CodeType="IVFAT"
                                                     id="FollicularPickupEndInfo.AnaesthesiaType"
                                                     [(ngModel)]="FollicularPickupEndInfo.AnaesthesiaType" SelectedValue="FollicularPickupEndInfo.AnaesthesiaType"
                                                     name="FollicularPickupEndInfo.AnaesthesiaType" required #Anaesthesia="ngModel">
                                      </CodeTypeValue>
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Needle Used </label>
                                    </div>


                                    <div class="col-md-4">
                                      <!--<input type="text" class="form-control" placeholder="Needle Used"
                                      id="FollicularPickupEndInfo.NeedleUsed"
                                      [(ngModel)]="FollicularPickupEndInfo.NeedleUsed"
                                      name="FollicularPickupEndInfo.NeedleUsed" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <CodeTypeValue CodeType="IVFPN"
                                                     id="FollicularPickupEndInfo.NeedleUsed"
                                                     [(ngModel)]="FollicularPickupEndInfo.NeedleUsed" SelectedValue="FollicularPickupEndInfo.NeedleUsed"
                                                     name="FollicularPickupEndInfo.NeedleUsed" required #Needle="ngModel">
                                      </CodeTypeValue>
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Batch </label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="Batch" id="FollicularPickupEndInfo.NeedleBatchName"
                                             [(ngModel)]="FollicularPickupEndInfo.NeedleBatchName"
                                             name="FollicularPickupEndInfo.NeedleBatchName" #Batch="ngModel"
                                             maxlength="100" required>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Route </label>
                                    </div>


                                    <div class="col-md-3">
                                      <!--<input type="text" class="form-control" placeholder="Batch" id="FollicularPickupEndInfo.Route"
                                      [(ngModel)]="FollicularPickupEndInfo.Route"
                                      name="FollicularPickupEndInfo.Route" #Route="ngModel"
                                      maxlength="10" required>-->
                                      <CodeTypeValue CodeType="IVFPR"
                                                     id="FollicularPickupEndInfo.Route"
                                                     [(ngModel)]="FollicularPickupEndInfo.Route" SelectedValue="FollicularPickupEndInfo.Route"
                                                     name="FollicularPickupEndInfo.Route" required #Route="ngModel">
                                      </CodeTypeValue>
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Complications </label>
                                    </div>


                                    <div class="col-md-3">
                                      <!--<input type="text" class="form-control" placeholder="Batch" id="FollicularPickupEndInfo.Complications"
                                      [(ngModel)]="FollicularPickupEndInfo.Complications"
                                      name="FollicularPickupEndInfo.Complications" #Complications="ngModel"
                                      maxlength="10" required>-->
                                      <CodeTypeValue CodeType="IVCPC"
                                                     id="FollicularPickupEndInfo.Complications"
                                                     [(ngModel)]="FollicularPickupEndInfo.Complications" SelectedValue="FollicularPickupEndInfo.Complications"
                                                     name="FollicularPickupEndInfo.Complications" required #Complication="ngModel">
                                      </CodeTypeValue>
                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitProcedureDetails()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="PickupData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                Procedure Details
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="Complication.errors?.required || Route.errors?.required || Batch.errors?.required || Needle.errors?.required || Anaesthesia.errors?.required  ">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>

                        </div>


                      </div>

                      <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Anaesthesia </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">

                                      <!--<CodeTypeValue CodeType="IVFAT"
                                                     id="FollicularPickupEndInfo.AnaesthesiaType"
                                                     [(ngModel)]="FollicularPickupEndInfo.AnaesthesiaType" SelectedValue="FollicularPickupEndInfo.AnaesthesiaType"
                                                     name="FollicularPickupEndInfo.AnaesthesiaType" required #Anaesthesia="ngModel">
                                      </CodeTypeValue>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.AnaesthesiaType}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Needle Used </label>
                                    </div>:


                                    <div class="col-md-4 margin-tg-auto">

                                      <!--<CodeTypeValue CodeType="IVFPN"
                                                     id="FollicularPickupEndInfo.NeedleUsed"
                                                     [(ngModel)]="FollicularPickupEndInfo.NeedleUsed" SelectedValue="FollicularPickupEndInfo.NeedleUsed"
                                                     name="FollicularPickupEndInfo.NeedleUsed" required #Needle="ngModel">
                                      </CodeTypeValue>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.NeedleUsed}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Batch </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">

                                      <!--<input type="text" class="form-control" placeholder="Batch" [disabled]="true" id="FollicularPickupEndInfo.NeedleBatchName"
                                      [(ngModel)]="FollicularPickupEndInfo.NeedleBatchName"
                                      name="FollicularPickupEndInfo.NeedleBatchName" #Batch="ngModel"
                                      maxlength="100" required>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.NeedleBatchName}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Route </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">

                                      <!--<CodeTypeValue CodeType="IVFPR"
                                                     id="FollicularPickupEndInfo.Route"
                                                     [(ngModel)]="FollicularPickupEndInfo.Route" SelectedValue="FollicularPickupEndInfo.Route"
                                                     name="FollicularPickupEndInfo.Route" required #Route="ngModel">
                                      </CodeTypeValue>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.Route}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="margin-bottom-0px">Complications </label>
                                    </div>:


                                    <div class="col-md-3 margin-tg-auto">

                                      <!--<CodeTypeValue CodeType="IVCPC"
                                                     id="FollicularPickupEndInfo.Complications"
                                                     [(ngModel)]="FollicularPickupEndInfo.Complications" SelectedValue="FollicularPickupEndInfo.Complications"
                                                     name="FollicularPickupEndInfo.Complications" required #Complication="ngModel">
                                      </CodeTypeValue>-->

                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.Complications}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitPickUpSizes()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                Follicle Size
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit"
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="PickupData2.ActivityStatus !=='Completed'">
                            Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                          </div>-->
                        </div>


                      </div>

                      <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-3">
                                  <label class="font-weight-normal font-size-14">Add/Edit</label>
                                </div>
                                <div class="col-md-3 text-align-right">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>
                              </div>

                            </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px" *ngIf="GradingModel">

                              <div class="row my-profile-form" *ngIf="GradingModel=='Well Culture'">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Minimum Pickup Sizes </label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="PickupSize" id="FollicularPickupEndInfo.MinPickupSize"
                                             [(ngModel)]="FollicularPickupEndInfo.MinPickupSize"
                                             name="FollicularPickupEndInfo.MinPickupSize" #Pickupsize="ngModel"
                                             maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pickupsize.valid && (Pickupsize.dirty || Pickupsize.touched) && Pickupsize.errors.required )"></small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pickupsize.valid && Pickupsize.errors.pattern)">(only numbers are allowed)</small>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row margin-top-10">
                                <div class="col-md-12">

                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new">

                                        <tr>

                                          <th class="font-weight-normal td-padding-tb background-primary">

                                          </th>
                                          <!--<th class="text-align-center">Day</th>-->
                                          <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                                            Right
                                          </th>


                                          <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                                            Left
                                          </th>
                                          <!--<th class="text-align-center">Start Time</th>-->












                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Follicles
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.RFollicleCount"
                                                   [(ngModel)]="FollicularPickupEndInfo.RFollicleCount"
                                                   name="FollicularPickupEndInfo.RFollicleCount" #Doctor="ngModel"
                                                   required />

                                          </td>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.LFollicleCount"
                                                   [(ngModel)]="FollicularPickupEndInfo.LFollicleCount"
                                                   name="FollicularPickupEndInfo.LFollicleCount" #Doctor="ngModel"
                                                   required />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Aspirated
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.RFollicleAspirated"
                                                   [(ngModel)]="FollicularPickupEndInfo.RFollicleAspirated"
                                                   (ngModelChange)="ChangeRFollicle($event)"
                                                   name="FollicularPickupEndInfo.RFollicleAspirated" #Doctor="ngModel"
                                                   required />
                                          </td>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.LFollicleAspirated"
                                                   [(ngModel)]="FollicularPickupEndInfo.LFollicleAspirated"
                                                   (ngModelChange)="ChangeLFollicle($event)"
                                                   name="FollicularPickupEndInfo.LFollicleAspirated" #Doctor="ngModel"
                                                   required />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Oocytes Retrieved
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.TotalRtOocytes"
                                                   [(ngModel)]="FollicularPickupEndInfo.TotalRtOocytes"
                                                   name="FollicularPickupEndInfo.TotalRtOocytes" #Doctor="ngModel"
                                                   required />
                                          </td>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.TotalLtOocytes"
                                                   [(ngModel)]="FollicularPickupEndInfo.TotalLtOocytes"
                                                   name="FollicularPickupEndInfo.TotalLtOocytes" #Doctor="ngModel"
                                                   required />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="td-padding-tb background-primary">
                                            Total
                                          </th>
                                          <td class="td-padding-tb font-weight-bold">
                                            <!--<input type="number" class="form-control"
                                            min="1" max="10" id="FollicularPickupEndInfo.TotalOocytes"
                                            [(ngModel)]="FollicularPickupEndInfo.TotalOocytes"
                                            name="FollicularPickupEndInfo.TotalOocytes" #Doctor="ngModel"
                                            required />-->
                                            <label>{{FollicularPickupEndInfo.TotalRtOocytes+ FollicularPickupEndInfo.TotalLtOocytes}}</label>
                                          </td>
                                          <td class="td-padding-tb font-weight-bold">
                                            <!--<input type="number" class="form-control"
                                            min="1" max="10" />-->
                                          </td>
                                        </tr>
                                      </table>

                                    </div>
                                  </div>

                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                <form class="form " novalidate="" (ngSubmit)="onSubmitPickUpSizes()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="PickupData2.ActivityStatus =='Completed'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapseFive"
                                      aria-expanded="true" aria-controls="collapseFive">
                                Follicle Size
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>

                        </div>


                      </div>

                      <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">

                            <div class="card-body padding-top-0px padding-bottom-0px" *ngIf="GradingModel">

                              <div class="row my-profile-form" *ngIf="GradingModel=='Well Culture'">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Minimum Pickup Sizes </label>
                                    </div>


                                    <div class="col-md-3">

                                      <input type="text" class="form-control" placeholder="PickupSize" id="FollicularPickupEndInfo.MinPickupSize"
                                             [(ngModel)]="FollicularPickupEndInfo.MinPickupSize"
                                             name="FollicularPickupEndInfo.MinPickupSize" #Pickupsize="ngModel"
                                             maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pickupsize.valid && (Pickupsize.dirty || Pickupsize.touched) && Pickupsize.errors.required )"></small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Pickupsize.valid && Pickupsize.errors.pattern)">(only numbers are allowed)</small>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row margin-top-10">
                                <div class="col-md-12">

                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new">

                                        <tr>

                                          <th class="font-weight-normal td-padding-tb background-primary">

                                          </th>
                                          <!--<th class="text-align-center">Day</th>-->
                                          <th class="font-weight-normal td-padding-tb background-primary text-align-left">
                                            Right
                                          </th>


                                          <th class="font-weight-normal td-padding-tb background-primary text-align-left">
                                            Left
                                          </th>
                                          <!--<th class="text-align-center">Start Time</th>-->












                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Follicles
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control text-align-end"
                                            min="1" max="10" id="FollicularPickupEndInfo.RFollicleCount"
                                            [(ngModel)]="FollicularPickupEndInfo.RFollicleCount"
                                            name="FollicularPickupEndInfo.RFollicleCount" #Doctor="ngModel"
                                            required />-->
                                            <label class="margin-bottom-0px">{{FollicularPickupEndInfo.RFollicleCount}}</label>
                                          </td>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control text-align-end"
                                            min="1" max="10" id="FollicularPickupEndInfo.LFollicleCount"
                                            [(ngModel)]="FollicularPickupEndInfo.LFollicleCount"
                                            name="FollicularPickupEndInfo.LFollicleCount" #Doctor="ngModel"
                                            required />-->
                                            <label class="margin-bottom-0px">{{FollicularPickupEndInfo.LFollicleCount}}</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Aspirated
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control text-align-end"
                                            min="1" max="10" id="FollicularPickupEndInfo.RFollicleAspirated"
                                            [(ngModel)]="FollicularPickupEndInfo.RFollicleAspirated"
                                            (ngModelChange)="ChangeRFollicle($event)"
                                            name="FollicularPickupEndInfo.RFollicleAspirated" #Doctor="ngModel"
                                            required />-->
                                            <label class="margin-bottom-0px">{{FollicularPickupEndInfo.RFollicleAspirated}}</label>
                                          </td>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control text-align-end"
                                            min="1" max="10" id="FollicularPickupEndInfo.LFollicleAspirated"
                                            [(ngModel)]="FollicularPickupEndInfo.LFollicleAspirated"
                                            (ngModelChange)="ChangeLFollicle($event)"
                                            name="FollicularPickupEndInfo.LFollicleAspirated" #Doctor="ngModel"
                                            required />-->
                                            <label class="margin-bottom-0px">{{FollicularPickupEndInfo.LFollicleAspirated}}</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Oocytes Retrieved
                                          </th>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control text-align-end"
                                            min="1" max="10" id="FollicularPickupEndInfo.TotalRtOocytes"
                                            [(ngModel)]="FollicularPickupEndInfo.TotalRtOocytes"
                                            name="FollicularPickupEndInfo.TotalRtOocytes" #Doctor="ngModel"
                                            required />-->
                                            <label class="margin-bottom-0px">{{FollicularPickupEndInfo.TotalRtOocytes}}</label>
                                          </td>
                                          <td class="td-padding-tb">
                                            <!--<input type="number" class="form-control text-align-end"
                                            min="1" max="10" id="FollicularPickupEndInfo.TotalLtOocytes"
                                            [(ngModel)]="FollicularPickupEndInfo.TotalLtOocytes"
                                            name="FollicularPickupEndInfo.TotalLtOocytes" #Doctor="ngModel"
                                            required />-->
                                            <label class="margin-bottom-0px">{{FollicularPickupEndInfo.TotalLtOocytes}}</label>
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="td-padding-tb background-primary">
                                            Total
                                          </th>
                                          <td class="td-padding-tb font-weight-bold">
                                            <!--<input type="number" class="form-control"
                                            min="1" max="10" id="FollicularPickupEndInfo.TotalOocytes"
                                            [(ngModel)]="FollicularPickupEndInfo.TotalOocytes"
                                            name="FollicularPickupEndInfo.TotalOocytes" #Doctor="ngModel"
                                            required />-->
                                            <label>{{FollicularPickupEndInfo.TotalRtOocytes+ FollicularPickupEndInfo.TotalLtOocytes}}</label>
                                          </td>
                                          <td class="td-padding-tb font-weight-bold">
                                            <!--<input type="number" class="form-control"
                                            min="1" max="10" />-->
                                          </td>
                                        </tr>
                                      </table>

                                    </div>
                                  </div>

                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="row margin-left-0px margin-top-15px">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample7">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px"
                           id="heading7">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapse7" aria-expanded="true" aria-controls="collapse7">
                                Procedures/Tests
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto"
                                    hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right"
                                    id="FileUpload" (click)="AddTests()"
                                    name="upload" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                          </div>-->
                        </div>


                      </div>

                      <div id="collapse7" class="collapse show" aria-labelledby="heading7" data-parent="#accordionExample7">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-3">
                                  <label class="font-weight-normal font-size-14">Add/Edit</label>
                                </div>
                                <div class="col-md-3 text-align-right">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>
                              </div>

                            </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row">
                                <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                                  <div class="table-component table-tests">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new">

                                        <tbody class="table-body">

                                          <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                            <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                            <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                            <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                            <td class="padding-top-4px padding-bottom-4px padding-right-0px">{{RowIndex+1}}</td>
                                            <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                              <div class="height-16px">
                                                <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                              </div>
                                              <div class="row-height-17px">
                                                <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                              </div>
                                              <div class="row-height-17px">
                                                <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                              </div>
                                            </td>
                                            <td class="padding-top-4px padding-bottom-4px">
                                              <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                                <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                              </a>-->
                                              <div class="test-icons float-right">
                                                <a (click)="delTEST(l)" title="Remove" *ngIf="!FollicularPickupEndInfo.IsPickedUp"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                                <a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit" *ngIf="!FollicularPickupEndInfo.IsPickedUp">
                                                  <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                </a>
                                              </div>
                                            </td>




                                          </tr>

                                        </tbody>
                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row margin-left-0px margin-top-15px">
                <div class="col-md-12 padding-left-0px">
                  <div class="accordion margin-bottom-20px" id="accordionExample8">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="heading8">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapse8" aria-expanded="true" aria-controls="collapse8">
                                Medicines
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                    name="upload" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                            <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                          </div>
                          <!--<div class="col-md-6">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                          </div>-->
                        </div>


                      </div>

                      <div id="collapse8" class="collapse show" aria-labelledby="heading8" data-parent="#accordionExample8">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-3">
                                  <label class="font-weight-normal font-size-14">Add/Edit</label>
                                </div>
                                <div class="col-md-3 text-align-right">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>
                              </div>

                            </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                              <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                                <div class="table-component">
                                  <div class="table-responsive">


                                    <table class="table table-striped margin-left-zero width-50-new">
                                      <!--<thead>
                                                                          <tr>
                                                                            <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                            <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                            </th>

                                                                            <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                      </th>
                                      <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                      </th>
                                      <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                      </th>


                                                                            <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                            </th>











                                                                          </tr>
                                                                        </thead>-->
                                      <tbody class="table-body">

                                        <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                          <td class="padding-top-4px padding-bottom-4px ">{{RowIndex+1}}</td>
                                          <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
    <div class="height-16px" >
      <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
    </div>
    <div class="height-16px" >
      <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
    </div>

  </td>-->
                                          <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.StartDate| date:'MMM-dd-yyyy'}}</td>
                                          <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                          <td class=" padding-top-4px padding-bottom-4px ">{{l.Dosage}}{{l.DurationType}}</td>
                                          <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                          <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                          <td class="padding-top-4px padding-bottom-4px ">
                                            <div class="test-icons float-right">
                                              <a (click)="delMedicine(l)" title="Remove" *ngIf="!FollicularPickupEndInfo.IsPickedUp"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                              <a (click)="EditMedicine(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="!FollicularPickupEndInfo.IsPickedUp">
                                                <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                              </a>
                                            </div>
                                          </td>
                                          <!--<td class="padding-top-4px padding-bottom-4px">


  </td>-->




                                        </tr>

                                      </tbody>
                                    </table>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
